import styles from './parts.module.css';

const PageHeader = ({ title, sub, actions }) => (
    <header className={styles.pageHead}>
        <div>
            <h1 className={styles.pageTitle}>{title}</h1>
            {sub && <p className={styles.pageSub}>{sub}</p>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
    </header>
);

export default PageHeader;
